module.exports = __webpack_public_path__ + "fonts/BebasNeue-Light.8e00a8c.woff2";